module.exports = __webpack_public_path__ + "img/logo15.11ae1af.jpg";